import React from "react";
import { Modal, Button } from "rsuite";
import { useTranslation } from "react-i18next";

const POLICY_CONTENT = {
  ru: {
    title: "Согласие на обработку персональных данных",
    intro: "Настоящим я даю свое согласие на обработку моих персональных данных в рамках использования информационной системы и связанных с ней сервисов.",
    sections: [
      {
        heading: "1. Какие данные могут обрабатываться",
        text: "В рамках работы сервиса могут обрабатываться следующие персональные данные:",
        items: [
          "Фамилия, имя, отчество (при наличии)",
          "Номер телефона",
          "Адрес электронной почты",
          "Данные учетной записи пользователя",
          "Информация, передаваемая пользователем при использовании сервиса",
          "Техническая информация об устройстве и действиях пользователя в системе (IP-адрес, сведения о браузере, операционной системе, файлы cookie, журналы событий и иные технические данные)",
        ],
      },
      {
        heading: "2. Цели обработки персональных данных",
        text: "Персональные данные обрабатываются для следующих целей:",
        items: [
          "предоставление доступа к функционалу сервиса",
          "идентификация и авторизация пользователя",
          "обработка запросов и обращений пользователей",
          "обеспечение корректной работы сервиса",
          "улучшение качества предоставляемых услуг",
          "выполнение требований законодательства",
          "информирование пользователя о работе сервиса и его обновлениях",
        ],
      },
      {
        heading: "3. Действия с персональными данными",
        text: "Оператор вправе осуществлять следующие действия с персональными данными: сбор, запись, систематизация, накопление, хранение, уточнение (обновление, изменение), использование, передача в случаях, предусмотренных законодательством, обезличивание, блокирование, удаление, уничтожение.",
      },
      {
        heading: "4. Передача данных третьим лицам",
        text: "Передача персональных данных третьим лицам допускается только в случаях, предусмотренных законодательством, либо когда такая передача необходима для функционирования сервиса и предоставления пользователю запрашиваемых услуг.",
      },
      {
        heading: "5. Срок хранения данных",
        text: "Персональные данные хранятся в течение срока, необходимого для достижения целей их обработки, либо в течение срока, установленного действующим законодательством.",
      },
      {
        heading: "6. Права пользователя",
        text: "Пользователь имеет право:",
        items: [
          "получать информацию об обработке своих персональных данных",
          "требовать уточнения, обновления или удаления своих персональных данных",
          "отозвать согласие на обработку персональных данных",
          "обращаться с вопросами, связанными с обработкой персональных данных",
        ],
      },
      {
        heading: "7. Отзыв согласия",
        text: "Пользователь вправе в любой момент отозвать свое согласие на обработку персональных данных путем направления соответствующего обращения оператору сервиса.",
      },
      {
        heading: "8. Заключительные положения",
        text: "Продолжая использование сервиса и подтверждая согласие, пользователь подтверждает, что ознакомился с настоящим документом, понимает его содержание и добровольно предоставляет согласие на обработку своих персональных данных.",
      },
    ],
  },
  en: {
    title: "Personal Data Processing Consent",
    intro: "By this, I give my consent to the processing of my personal data within the scope of using the information system and its related services.",
    sections: [
      {
        heading: "1. What Data May Be Processed",
        text: "The following personal data may be processed within the service:",
        items: [
          "Last name, first name, middle name (if applicable)",
          "Phone number",
          "Email address",
          "User account data",
          "Information provided by the user while using the service",
          "Technical information about the device and user actions in the system (IP address, browser information, operating system, cookies, event logs and other technical data)",
        ],
      },
      {
        heading: "2. Purposes of Personal Data Processing",
        text: "Personal data is processed for the following purposes:",
        items: [
          "providing access to service functionality",
          "user identification and authorization",
          "processing user requests and inquiries",
          "ensuring proper operation of the service",
          "improving the quality of provided services",
          "fulfilling legal requirements",
          "informing the user about service updates and changes",
        ],
      },
      {
        heading: "3. Actions with Personal Data",
        text: "The operator has the right to perform the following actions with personal data: collection, recording, systematization, accumulation, storage, clarification (updating, modification), use, transfer in cases provided by law, anonymization, blocking, deletion, destruction.",
      },
      {
        heading: "4. Transfer of Data to Third Parties",
        text: "Transfer of personal data to third parties is permitted only in cases provided by law, or when such transfer is necessary for the functioning of the service and provision of the services requested by the user.",
      },
      {
        heading: "5. Data Retention Period",
        text: "Personal data is stored for the period necessary to achieve the purposes of its processing, or for the period established by applicable law.",
      },
      {
        heading: "6. User Rights",
        text: "The user has the right to:",
        items: [
          "receive information about the processing of their personal data",
          "request clarification, updating or deletion of their personal data",
          "withdraw consent to the processing of personal data",
          "address questions related to the processing of personal data",
        ],
      },
      {
        heading: "7. Withdrawal of Consent",
        text: "The user may at any time withdraw their consent to the processing of personal data by sending the appropriate request to the service operator.",
      },
      {
        heading: "8. Final Provisions",
        text: "By continuing to use the service and confirming consent, the user confirms that they have read this document, understand its content and voluntarily consent to the processing of their personal data.",
      },
    ],
  },
  kz: {
    title: "Жеке деректерді өңдеуге келісім",
    intro: "Осымен мен ақпараттық жүйені және онымен байланысты қызметтерді пайдалану шеңберінде жеке деректерімді өңдеуге келісімімді беремін.",
    sections: [
      {
        heading: "1. Қандай деректер өңделуі мүмкін",
        text: "Сервис жұмысы шеңберінде келесі жеке деректер өңделуі мүмкін:",
        items: [
          "Тегі, аты, әкесінің аты (болса)",
          "Телефон нөмірі",
          "Электрондық пошта мекенжайы",
          "Пайдаланушы тіркелгісінің деректері",
          "Пайдаланушы сервисті пайдалану кезінде берген ақпарат",
          "Жүйедегі құрылғы мен пайдаланушы әрекеттері туралы техникалық ақпарат (IP-мекенжай, браузер туралы мәліметтер, операциондық жүйе, cookie файлдары, оқиғалар журналы және басқа техникалық деректер)",
        ],
      },
      {
        heading: "2. Жеке деректерді өңдеу мақсаттары",
        text: "Жеке деректер келесі мақсаттар үшін өңделеді:",
        items: [
          "сервис функционалына қол жеткізуді қамтамасыз ету",
          "пайдаланушыны сәйкестендіру және авторизациялау",
          "пайдаланушылардың сұраулары мен өтініштерін өңдеу",
          "сервистің дұрыс жұмысын қамтамасыз ету",
          "көрсетілетін қызметтер сапасын жақсарту",
          "заңнама талаптарын орындау",
          "пайдаланушыны сервис жұмысы және оның жаңартулары туралы хабардар ету",
        ],
      },
      {
        heading: "3. Жеке деректермен жасалатын іс-әрекеттер",
        text: "Оператор жеке деректермен келесі іс-әрекеттерді жүргізуге құқылы: жинау, тіркеу, жүйелеу, жинақтау, сақтау, нақтылау (жаңарту, өзгерту), пайдалану, заңнамада көзделген жағдайларда беру, дербестендіру, блоктау, жою, жоқ қылу.",
      },
      {
        heading: "4. Деректерді үшінші тұлғаларға беру",
        text: "Жеке деректерді үшінші тұлғаларға беруге тек заңнамада көзделген жағдайларда немесе сервистің жұмыс істеуі және пайдаланушыға сұралған қызметтерді ұсыну үшін мұндай беру қажет болғанда жол беріледі.",
      },
      {
        heading: "5. Деректерді сақтау мерзімі",
        text: "Жеке деректер оларды өңдеу мақсаттарына жету үшін қажетті мерзім ішінде немесе қолданыстағы заңнамада белгіленген мерзім ішінде сақталады.",
      },
      {
        heading: "6. Пайдаланушының құқықтары",
        text: "Пайдаланушы:",
        items: [
          "жеке деректерін өңдеу туралы ақпарат алуға",
          "жеке деректерін нақтылауды, жаңартуды немесе жоюды талап етуге",
          "жеке деректерін өңдеуге берілген келісімді кері қайтарып алуға",
          "жеке деректерді өңдеуге байланысты мәселелер бойынша жүгінуге құқылы",
        ],
      },
      {
        heading: "7. Келісімді кері қайтарып алу",
        text: "Пайдаланушы кез келген уақытта сервис операторына тиісті өтінішті жіберу арқылы жеке деректерін өңдеуге берілген келісімін кері қайтарып алуға құқылы.",
      },
      {
        heading: "8. Қорытынды ережелер",
        text: "Сервисті пайдалануды жалғастыра отырып және келісімін растай отырып, пайдаланушы осы құжатпен танысқанын, оның мазмұнын түсінетінін және жеке деректерін өңдеуге ерікті түрде келісім беретінін растайды.",
      },
    ],
  },
};

export default function PrivacyPolicyModal({ open, onClose, language }) {
  const { t } = useTranslation("basic");
  const content = POLICY_CONTENT[language] || POLICY_CONTENT.ru;

  return (
    <Modal size="sm" open={open} onClose={onClose}>
      <Modal.Header>
        <Modal.Title>{content.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ overflow: "auto", maxHeight: "60vh" }}>
        <h3>{content.title}</h3>
        <p>{content.intro}</p>
        {content.sections.map((section) => (
          <div key={section.heading}>
            <h4>{section.heading}</h4>
            <p>{section.text}</p>
            {section.items && (
              <ul>
                {section.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose} appearance="primary">
          {t("close")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
